/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Neonpay
 */
export class Neonpay {
    /**
     *
     * @type {string}
     * @memberof Neonpay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Neonpay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Neonpay
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Neonpay
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Neonpay
     */
    merchantKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Neonpay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Neonpay
     */
    autoApprove: boolean;
}
